import { VendorsView  } from '../../Views/Home/VendorsView' ; 
import { VendorsProfileManagementView} from '../../Views/Home/VendorsView/VendorsUtilities' ; 
export const VendorsRoutes = [
  {

    path: "/view",
    name: "Vendors:vendors",
    component: VendorsView ,
    layout: "/home/vendors",
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: "Vendors:vendors",
        isDisabled: true,
        route: "/home/vendors/view",
        groupName: 'partner-hub',

      },
    ],
  },
  {
    path: '/vendor-profile-edit',
    name: 'Vendors:vendor-profile-edit',
    component: VendorsProfileManagementView,
    layout: '/home/vendors',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: "Vendors:vendors",
        isDisabled: false,
        route: '/home/vendors/view',
        groupName: 'partner-hub',
      },
      {
        name: 'Vendors:vendor-profile-edit',
        isDisabled: true,
        route: '/home/vendors/vendor-profile-edit',
      },
    ],
  },
];
